import { gql } from 'graphql-request';

export const get_query = () => gql`
  query {
    application {
      sections {
        id
        name
        state
        frames {
          id
          flex
        }
      }
      firstSection {
        id
        button
        frames {
          id
          flex
          components {
            id
            type
            label
            action
            variant
            options {
              id
              label
            }
            default_value
            required
            conditionals {
              component_id
              value
            }
            value
            answer
          }
        }
      }
    }
  }
`;

export const get_applicant_by_id = () => gql`
  query findApplicantByID($applicationID: UUID!) {
    findApplicantByID(id: $applicationID) {
      id
      vtwaId
      interviewUrl
      status
    }
  }
`;

export const get_subjects = () => gql`
  query {
    getAllSubjects(filters: { tutoringSessionEnabled: true }) {
      id
      label: displayName
      shortName
      parent {
        name
      }
    }
  }
`;

export const get_states = () => gql`
  query {
    getAllStates {
      id
      label: name
    }
  }
`;

export const submit_mutation = () => gql`
  mutation submitApplicationAnswers(
    $application_id: String
    $answers: [ComponentAnswerInput!]!
    $utm_params: UTMParamsInput
  ) {
    submitApplicationAnswers(
      applicationID: $application_id
      components: $answers
      utmParams: $utm_params
    ) {
      id
      complete
      application {
        id
        sections {
          id
          name
          state
          button
          frames {
            id
            flex
            components {
              id
              type
              label
              action
              variant
              options {
                id
                label
              }
              default_value
              required
              conditionals {
                component_id
                value
              }
              value
              answer
            }
          }
        }
      }
      activeSection {
        id
        button
        frames {
          flex
          components {
            id
            type
            label
            variant
            action
            options {
              id
              label
            }
            default_value
            required
            conditionals {
              component_id
              value
            }
            value
            answer
          }
        }
      }
    }
  }
`;

/*
 * This is a helper function that will parse a JSON string and return the parsed object
 * or the original string if it fails to parse.
 */
export const json_parser = (json: string) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return json;
  }
};

export const zipcode_mask_by_country = (country: number) => {
  // Mask for united states
  if (country === 1) {
    return '99999';
  }
  // Mask for Canada
  if (country === 2) {
    return 'a9a 9a9';
  }
  // Mask for Mexico
  if (country === 4) {
    return '99999';
  }
  // Mask for India
  if (country === 5) {
    return '999999';
  }
};

export const phone_mask_by_country = (country: number) => {
  // Mask for united states
  if (country === 1) {
    return '+1 (999) 999-9999';
  }
  // Mask for Canada
  if (country === 2) {
    return '+1 (999) 999-9999';
  }
  // Mask for united kingdom
  if (country === 3) {
    return '+44 9999 999999';
  }
  // Mask for Mexico
  if (country === 4) {
    return '+52 999 999 9999';
  }
  // mask for india
  if (country === 5) {
    return '+91 99999 99999';
  }
};

export function getState(zipString) {
  const zipcode = parseInt(zipString, 10);
  // if (isNaN(zipcode)) {
  //   return '';
  // }
  const stateLookup = {
    '35000-36999': 'AL',
    '99500-99999': 'AK',
    '85000-86999': 'AZ',
    '71600-72999': 'AR',
    '90000-96699': 'CA',
    '80000-81999': 'CO',
    '6000-6389,6391-6999': 'CT',
    '19700-19999': 'DE',
    '32000-34999': 'FL',
    '30000-31999,39800-39999': 'GA',
    '96700-96999': 'HI',
    '83200-83999,83414': 'ID',
    '60000-62999': 'IL',
    '46000-47999': 'IN',
    '50000-52999': 'IA',
    '66000-67999': 'KS',
    '40000-42999': 'KY',
    '70000-71599': 'LA',
    '3900-4999': 'ME',
    '20600-21999': 'MD',
    '1000-2799,5501,5544': 'MA',
    '48000-49999': 'MI',
    '55000-56899': 'MN',
    '38600-39999': 'MS',
    '63000-65999': 'MO',
    '59000-59999': 'MT',
    '27000-28999': 'NC',
    '58000-58999': 'ND',
    '68000-69999': 'NE',
    '88900-89999': 'NV',
    '3000-3899': 'NH',
    '7000-8999': 'NJ',
    '87000-88499': 'NM',
    '10000-14999,6390,501,544': 'NY',
    '43000-45999': 'OH',
    '73000-73199,73400-74999': 'OK',
    '97000-97999': 'OR',
    '15000-19699': 'PA',
    '300-999': 'PR',
    '2800-2999': 'RI',
    '29000-29999': 'SC',
    '57000-57999': 'SD',
    '37000-38599': 'TN',
    '75000-79999,73301-73399,88500-88599': 'TX',
    '84000-84999': 'UT',
    '5000-5999': 'VT',
    '20100-20199,22000-24699,20598': 'VA',
    '20000-20099,20200-20599,56900-56999': 'DC',
    '98000-99499': 'WA',
    '24700-26999': 'WV',
    '53000-54999': 'WI',
    '82000-83199,83414': 'WY',
  };

  for (const range of Object.keys(stateLookup)) {
    const [start, end] = range.split('-');
    const zipStart = parseInt(start, 10);
    const zipEnd = parseInt(end, 10);
    if (zipcode >= zipStart && zipcode <= zipEnd) {
      return stateLookup[range];
    }
  }

  return 'none';
}
